import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Divider, Icon, Input, Row, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { CUSTOMER_ENDPOINT } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const resp = await CommonService.get(CUSTOMER_ENDPOINT, {
				page: page.currentPage - 1,
				size: page.perpage
			});
			setDs(resp.data?.contents);
			setPage({ ...page, total: resp.data?.totalElements });
			window.setLoading(false);
		};
		window.setLoading(true);
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(CUSTOMER_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã khách hàng',
			dataIndex: 'customerCode',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return <Button style={{ padding: '0', height: 'fit-content' }} type={'link'}
											 onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Tên khách hàng',
			dataIndex: 'name',
			className: 'header-center-align',
			width: 200
		},
		{
			title: 'Số điện thoại',
			dataIndex: 'phoneNumber',
			className: 'header-center-align',
			width: 150
		},
		// {
		// 	title: 'Email',
		// 	dataIndex: 'email',
		// 	className: 'header-center-align',
		// 	width: 150
		// },
		{
			title: 'Cộng nợ hiện tại',
			dataIndex: 'totalDebt',
			className: 'header-center-align',
			width: 150,
			render: (text) => (<span>{currencyVND(text)}</span>)
		},
		// {
		// 	title: 'Tổng chi tiêu',
		// 	dataIndex: 'totalInvoice',
		// 	width: 110,
		// 	align: 'center',
		// 	render: (text) => (<span>{currencyVND(text)}</span>)
		// },
		{
			title: 'Tổng SL đơn hàng',
			dataIndex: 'totalOrder',
			width: 110,
			align: 'center'
		},
		{
			title: 'Trạng thái khách hàng',
			dataIndex: 'isTransaction',
			width: 110,
			align: 'center',
			render: (value) => value ? <Tag style={{ width: '110px' }} color="#87d068">Đang giao dịch</Tag> :
				<Tag style={{ width: '110px' }} color="#f50">Ngừng giao dịch</Tag>
		},
		// {
		// 	title: 'Ngày mua hàng gần nhất',
		// 	dataIndex: 'latestOrder',
		// 	width: 200,
		// 	align: 'center',
		// 	render: (text) => (<span>{dateToString(text)}</span>)
		// },
		// {
		// 	title: 'Thao tác',
		// 	width: 100,
		// 	align: 'center',
		// 	render: (el) => (<Button onClick={() => gotoEdit(el.id)}>Sửa</Button>)
		// }
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const gotoCreate = () => {
		history.push('/customer/create');
	};

	const gotoDetail = (id) => {
		history.push('/customer/' + id);
	};

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};


	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
						<Divider type="vertical" />
						<Icon type="upload" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '200px' }} id={'btn-create-product'} icon="plus"
									onClick={gotoCreate}>Thêm mới khách hàng</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã khách hàng, SĐT, tên khách hàng"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
					/>
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
			/>
		</Fragment>

	);
};
